import { useRouter } from "next/router.js";
import { useEffect } from "react";
function fbqTrack() {
    //@ts-ignore
    if (typeof window?.["fbq"] !== "undefined") {
        // safe to use the function
        //@ts-ignore
        window["fbq"]('track', 'PageView');
    }
}
export default function useFacebookPixel() {
    const router = useRouter();
    useEffect(() => {
        const handleRouteChange = () => {
            fbqTrack();
        };
        router.events.on('routeChangeStart', handleRouteChange);
        // If the component is unmounted, unsubscribe
        // from the event with the `off` method:
        return () => {
            router.events.off('routeChangeStart', handleRouteChange);
        };
    }, [router?.events]);
}
